import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import Shipment from '~/types/Shipment';

export type ShipmentsState = {
  readonly data: { [shipmentObjectId: string]: Readonly<Shipment> };
  readonly allIds: readonly string[];
  readonly loadState: { [shipmentObjectId: string]: boolean };
};

const initialState: ShipmentsState = {
  data: {},
  allIds: [],
  loadState: {},
};

function reducer(state: ShipmentsState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.SHIPMENT_FETCH:
      return {
        ...state,
        loadState: {
          ...state.loadState,
          [action.shipmentId]: true,
        },
      };
    case ActionKeys.SHIPMENT_FETCH_SUCCESS:
      const shipmentIdIndex = state.allIds.findIndex(
        (id) => id === action.payload.shipment.objectId,
      );

      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.shipment.objectId]: action.payload.shipment,
        },
        allIds:
          shipmentIdIndex === -1
            ? [...state.allIds, action.payload.shipment.objectId]
            : state.allIds,
        loadState: {
          ...state.loadState,
          [action.shipmentId]: false,
        },
      };
    // Implement error handling
    case ActionKeys.SHIPMENT_FETCH_ERROR:
      return {
        ...state,
        loadState: {
          ...state.loadState,
          [action.payload.shipmentObjectId]: false,
        },
      };
    // Resets state after the package information is saved, this cleans
    // the state when the user re-sends the batch information
    case ActionKeys.ORDERS_BATCH_SAVE_PACKAGE_INFORMATION:
      return initialState;
    default:
      return state;
  }
}

export default reducer;
